/* eslint-disable react-hooks/exhaustive-deps */
import Form from "../../../../shared/forms/Form";
import Field from "../../../../shared/forms/Field";
import {Dialog} from "primereact/dialog";
import React, {useEffect, useState} from "react";
import {Button} from "primereact/button";
import useForm from "../../../../shared/forms/useForm";
import useApiSeguimientoMonitoreo from "../../../../api/operaciones/useApiSeguimientoMonitoreo";
import FieldCalendar from "../../../../shared/controls/fieldCalendar";
import FieldTime from "../../../../shared/controls/fieldTime";
import alerts from "../../../../shared/alerts";

const RegistrarRealModal = ({viaje, geocercaActual, setGeocercaActual, onChangeGeocerca}) => {

    const [submitted, setSubmitted] = useState(false);
    const api = useApiSeguimientoMonitoreo()

    const {
        values,
        onChange,
        onValidate,
        isValid,
        setValues
    } = useForm();

    useEffect(() => { setValues({}) }, [geocercaActual]);

    const visible = geocercaActual != null

    const enviarFechaReal = async () => {

        setSubmitted(true);

        if (!isValid)
            return;

        if (values.fecha == null || values.hora == null) {
            alerts.aviso('Debe ingresar la fecha y hora');
            return;
        }

        if(await alerts.preguntarSiNo('Desea registrar la fecha real?')) {

            await api.registrarFechaReal(viaje.id, {
                viajeGeocercaId: geocercaActual.viajeGeocercaId,
                fecha: values.fecha,
                hora: values.hora
            });
            setGeocercaActual(null)
            onChangeGeocerca()
        }
    }

    const renderFooterModal = () => {
        return (
            <>
                <div className="p-1">
                    <Button label={ `Registrar Fecha Real`} onClick={enviarFechaReal} type="button"/>
                </div>
            </>
        );
    };

    return (
        <Dialog header="Registrar Fecha Real" visible={visible} style={{width: '300px'}}
                onHide={() => setGeocercaActual(null)}
                footer={renderFooterModal}
        >
            <Form columns={1} values={values} onChange={onChange} onValidate={onValidate} submitted={submitted}>
                <Field label={'Fecha'} field={'fecha'} render={FieldCalendar} />
                <Field label={'Hora'} field={'hora'} render={FieldTime}/>
            </Form>
        </Dialog>
    )
}
export default RegistrarRealModal;